import React, { useState, useEffect } from "react";
import { CompanyList } from "components/Public/CompanyList";
import {useGetPublicCompaniesQuery} from "../../store/services/publicApi";
import {useLocation} from "react-router-dom";

const PublicCompanies = () => {
    const [searchTerm, setSearchTerm] = useState("");
    const [debouncedSearch, setDebouncedSearch] = useState("");

    const location = useLocation();
    const queryParams = new URLSearchParams(location.search);
    const initialPage = parseInt(queryParams.get("page") || "1");
    const [currentPage, setCurrentPage] = useState(initialPage);
    const companiesPerPage = 9;

    useEffect(() => {
        const timer = setTimeout(() => {
            setDebouncedSearch(searchTerm);
            setCurrentPage(1); // Reset to first page on new search
        }, 500);
        return () => clearTimeout(timer);
    }, [searchTerm]);

    const skip = (currentPage - 1) * companiesPerPage;

    const { data, isLoading, error } = useGetPublicCompaniesQuery({
        searchText: debouncedSearch || undefined,
        skip: skip
    });

    const {totalCount, companies} = data || {totalCount: 0, companies: []}

    const handlePageChange = (page: number) => {
        setCurrentPage(page);
    };

    return (
        <div className="public-companies-page">
            <section className="oec-jobs-hero">
                <div className="oec-section-inner">
                    <h1>Our <span>Partner</span> Companies</h1>
                    <p>Connect with leading organizations driving the energy transition in Ethiopia and beyond.</p>
                    <form className="oec-jobs-search" onSubmit={(event) => event.preventDefault()}>
                        <i className="fas fa-search"/>
                        <input
                            type="search"
                            placeholder="Search companies..."
                            value={searchTerm}
                            onChange={(event) => setSearchTerm(event.target.value)}
                            aria-label="Search companies"
                        />
                        <button className="oec-search-btn" type="submit">Search</button>
                    </form>
                </div>
            </section>

            <section className="oec-section">
                <CompanyList
                    companies={companies}
                    isLoading={isLoading}
                    error={error}
                    totalCount={totalCount}
                    itemsPerPage={companiesPerPage}
                    currentPage={currentPage}
                    onPageChange={handlePageChange}
                    emptyMessage="No companies found"
                    showPagination={true}
                />
            </section>
        </div>
    );
};

export default PublicCompanies;
